/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type child_extras_CreateChildExtraRequest = {
    /**
     * AmountCents is the signed amount in minor units (Rappen). Positive = debit
     * (charge), negative = credit. No VAT.
     */
    amountCents?: number;
    /**
     * InternalComment is admin-only.
     */
    internalComment?: string;
    /**
     * ParentComment is printed next to the line on the invoice.
     */
    parentComment?: string;
    /**
     * ServiceDate is the calendar date the extra relates to (YYYY-MM-DD). It
     * determines the target invoice period.
     */
    serviceDate: string;
    /**
     * Type is one of EINSCH, EMPFEHL, MISC, LEGACY, SETTLING_IN, TERMINATION.
     */
    type: child_extras_CreateChildExtraRequest.type;
};
export namespace child_extras_CreateChildExtraRequest {
    /**
     * Type is one of EINSCH, EMPFEHL, MISC, LEGACY, SETTLING_IN, TERMINATION.
     */
    export enum type {
        EINSCH = 'EINSCH',
        EMPFEHL = 'EMPFEHL',
        MISC = 'MISC',
        LEGACY = 'LEGACY',
        SETTLING_IN = 'SETTLING_IN',
        TERMINATION = 'TERMINATION',
    }
}

